import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GetMyShoppingKitPaymentResponse } from '../../../shared/services/responses/platform/get-my-shopping-kit-payment.response';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FooterComponent } from '../../../shared/components/footer/footer.component';
import { MyShoppingService } from '../../../shared/services/apis/platform/my-shopping.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';

@Component({
  selector: 'app-my-shopping-item',
  standalone: true,
  imports: [
    CommonModule,
    MenuComponent,
    FooterComponent,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DatePipe
  ],
  templateUrl: './my-shopping-item.component.html',
  styleUrls: ['./my-shopping-item.component.css']
})
export class MyShoppingItemComponent implements OnInit {
  isLoading = true;
  pedido: GetMyShoppingKitPaymentResponse | null = null;
  idKitPaymentItem: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private myShoppingService: MyShoppingService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    const idParam = this.route.snapshot.paramMap.get('idKitPaymentItem');
    if (idParam) {
      this.idKitPaymentItem = +idParam;
      this.loadPedido();
    } else {
      this.alertService.show('Erro', 'ID do item do pedido não encontrado na rota.', AlertType.error);
      this.isLoading = false;
    }
  }

  loadPedido(): void {
    this.isLoading = true;
    this.myShoppingService.getById(this.idKitPaymentItem).subscribe({
      next: (response) => {
        this.isLoading = false;

        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.pedido = response;


      },
      error: (error) => {
        this.alertService.show('Erro', 'Não foi possível carregar os detalhes do pedido.', AlertType.error);
        console.error(error);
        this.isLoading = false;
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/minhas-compras']);
  }
}